import * as C from './styles';
import { useHistory } from 'react-router-dom';
import { useForm, FormActions } from '../../context/FormContext';
import { Theme } from '../../components/Theme/intex';
import { ChangeEvent, useEffect, useState } from 'react';
import { executeCreateUserApi } from '../../components/Api/api';
import { validateCNPJ } from '../../components/Api/cnpjValidation'; // Importando a função de validação de CNPJ
import Modal from '../../components/Modal'; // Importando o componente Modal
import HCaptcha from '@hcaptcha/react-hcaptcha'; // Importando o hCaptcha

export const FormStep1 = () => {
    const history = useHistory();
    const { state, dispatch } = useForm();

    const [cnpjValue, setCnpjValue] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [contactName, setContactName] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [cnpjErrorMessage, setCnpjErrorMessage] = useState('');
    const [errors, setErrors] = useState({
        name: false,
        contact: false,
        cnpj: false,
        email: false,
        phone: false
    });
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

    const emailRegex = /^[^@\s]+@[^@\s.]+\.[^@\s]+(\.[^@\s]+)?$/;
    const phoneRegex = /^\d{11}$/;

    const sanitizeName = (name: string): string => {
        return name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9\s]/g, '').trim();
    };

    const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: FormActions.setName,
            payload: e.target.value.trim().replace(/[\s]{2,}/g, ' ')
        });
        setErrors({ ...errors, name: false });
    };

    const handleContactNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        setContactName(e.target.value.trim().replace(/[\s]{2,}/g, ' '));
        setErrors({ ...errors, contact: false });
    };

    const handleCnpjChange = (e: ChangeEvent<HTMLInputElement>) => {
        const onlyNumbers = e.target.value.replace(/[^\d]/g, '');
        setCnpjValue(onlyNumbers);
        setErrors({ ...errors, cnpj: false });
    };

    const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value.toLowerCase());
        setErrors({ ...errors, email: false });
    };

    const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPhone(e.target.value.replace(/[^\d]/g, ''));
        setErrors({ ...errors, phone: false });
    };

    const handlePhoneKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const validateCnpjInput = async () => {
        try {
            const isValid = await validateCNPJ(cnpjValue);
            if (!isValid) {
                setErrors({ ...errors, cnpj: true });
                setCnpjErrorMessage('CNPJ inválido ou não cadastrado na Receita Federal.');
                return false;
            }
            return true;
        } catch (error) {
            setErrors({ ...errors, cnpj: true });
            setCnpjErrorMessage('Erro ao validar o CNPJ. Tente novamente mais tarde.');
            return false;
        }
    };

    const validateEmail = () => {
        if (!emailRegex.test(email) || /gmail\.com|hotmail\.com|outlook\.com|live\.com/.test(email)) {
            setErrors({ ...errors, email: true });
            return false;
        }
        return true;
    };

    const validatePhone = () => {
        if (!phoneRegex.test(phone)) {
            setErrors({ ...errors, phone: true });
            return false;
        }
        return true;
    };

    const handleCaptchaChange = (token: string) => {
        setIsCaptchaVerified(true);
    };

    const handleNextStep = async () => {
        const isCnpjValid = await validateCnpjInput();
        const isEmailValid = validateEmail();
        const isPhoneValid = validatePhone();
        const sanitizedCompanyName = sanitizeName(state.name);

        if (isCnpjValid && sanitizedCompanyName && isEmailValid && isPhoneValid && contactName && isCaptchaVerified) {
            dispatch({ type: FormActions.setName, payload: sanitizedCompanyName });
            dispatch({ type: FormActions.setCnpj, payload: cnpjValue });
            dispatch({ type: FormActions.setEmail, payload: email });
            dispatch({ type: FormActions.setPhone, payload: phone });
            dispatch({ type: FormActions.setContact, payload: contactName });

            console.log('Nome da Empresa:', sanitizedCompanyName);
            console.log('Nome do Contato:', contactName);
            console.log('CNPJ:', cnpjValue);
            console.log('Email:', email);
            console.log('Telefone:', phone);

            try {
                const groupid = await executeCreateUserApi(sanitizedCompanyName, cnpjValue, email, phone);
                dispatch({ type: FormActions.setGroupId, payload: groupid }); // Atualiza o groupid no estado global
                setModalMessage(`Cadastro de ${sanitizedCompanyName}\nrealizado com sucesso!`); // Define a mensagem de sucesso
            } catch (error) {
                console.error('Erro ao executar API:', error);
                setErrors({ ...errors, name: true });
                if (error instanceof Error) {
                    setModalMessage(`Falha ao processar dados da API. Detalhes: ${error.message}`);
                } else {
                    setModalMessage('Falha ao processar dados da API. Erro desconhecido.');
                }
            }
        } else {
            if (!sanitizedCompanyName) {
                setErrors({ ...errors, name: true });
            }
            if (!contactName) {
                setErrors({ ...errors, contact: true });
            }
            if (!isCaptchaVerified) {
                setModalMessage('Por favor, complete o CAPTCHA.');
            }
            if (!isCnpjValid || !isEmailValid || !isPhoneValid) {
                setModalMessage('Preencha os campos marcados corretamente.');
            }
        }
    };

    const closeModal = () => {
        setModalMessage('');
        if (modalMessage.includes('realizado com sucesso')) {
            history.push('/step2');
        }
    };

    const closeCnpjErrorModal = () => {
        setCnpjErrorMessage('');
    };

    useEffect(() => {
        dispatch({
            type: FormActions.setCurrentStep,
            payload: 1
        });
    }, [dispatch]);

    return (
        <Theme>
            <C.Container>
                <p className='passo'>Passo 1/3</p>
                <h2>Vamos começar identificando sua empresa</h2>
                <p>Preencha o campo com os dados de sua empresa</p>

                <label>Nome da Empresa</label>
                <input 
                    type="text" 
                    autoFocus
                    placeholder="O nome que vai identificar sua empresa"
                    onChange={handleNameChange}
                    className={errors.name ? 'error' : ''}
                />
                {errors.name && <span style={{ color: 'red' }}>Nome da Empresa é obrigatório.</span>}

                <label>Nome do Contato</label>
                <input 
                    type="text" 
                    placeholder="Qual nome de contato na empresa"
                    onChange={handleContactNameChange}
                    className={errors.contact ? 'error' : ''}
                />
                {errors.contact && <span style={{ color: 'red' }}>Nome do Contato é obrigatório.</span>}

                <label>CNPJ</label>
                <input 
                    type="text" 
                    placeholder="Seu CNPJ com 14 dígitos"
                    onChange={handleCnpjChange}
                    value={cnpjValue}
                    className={errors.cnpj ? 'error' : ''}
                />
                {errors.cnpj && <span style={{ color: 'red' }}>CNPJ Invalido ou não cadastrado na Receita Federal</span>}

                <label>Email Corporativo</label>
                <input 
                    type="email" 
                    placeholder="Seu email com domínio privado"
                    onChange={handleEmailChange}
                    value={email}
                    className={errors.email ? 'error' : ''}
                />
                {errors.email && <span style={{ color: 'red' }}>Email inválido ou domínio não permitido.</span>}

                <label>Telefone</label>
                <input 
                    type="text" 
                    placeholder="Prefixo + 9 dígitos"
                    onChange={handlePhoneChange}
                    onKeyPress={handlePhoneKeyPress}
                    value={phone}
                    className={errors.phone ? 'error' : ''}
                />
                {errors.phone && <span style={{ color: 'red' }}>Telefone inválido, deve seguir o formato (DD)NNNNNNNNN.</span>}

                <div className="captcha-wrapper">
                    <HCaptcha
                        sitekey="7f85b157-1f66-4033-b0b8-3bdfe3528a76"
                        onVerify={handleCaptchaChange}
                        size="normal" // Para usar a caixa de seleção "Não sou um robô"
                    />
                </div>

                <button onClick={handleNextStep}>Próximo</button>

                {modalMessage && <Modal message={modalMessage} onClose={closeModal} />}
                {cnpjErrorMessage && <Modal message={cnpjErrorMessage} onClose={closeCnpjErrorModal} />}
            </C.Container>
        </Theme>
    );
};
